import React from 'react'

import { RowFlexDiv } from './CommonStyle'

const OnlineStatus = ({ marginLeft, marginTop }) => {
  return (
    <RowFlexDiv
      marginLeft={marginLeft}
      marginTop={marginTop}
      borderRadius='50%'
      // opacity={rightNavbarMinified ? '0' : '1'}
      width='8px'
      height='8px'
      backgroundColor='#2FF974'
      outline='3px solid #DCD9E0'
      position='absolute'
      // zIndex='9111'
    ></RowFlexDiv>
  )
}

export default OnlineStatus
